function e(r) {
  return typeof r == "string" ? document.querySelector(r) : r();
}
export {
  e as resolveTo
};
